<template>
  <div>
    <editor :initial="dataItem" :backUrl="backUrl" :docTitle="docTitle" :noTitle="noTitle"></editor>
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>

<script>
import Editor from "../_components/preview-editor.vue";
export default {
  components: {
    Editor
  },
  data: () => ({
    dataItem: {},
    docTitle: "Quotation",
    backUrl: "/quotations",
    noTitle: "Quote"
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      var url = `/sale-document/${val}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  }
};
</script>